// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UsersTableElements_container__G23uv {
  display: flex;
  padding: 5px 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  justify-content: space-between;
  width: 90%;
  color: #676c7e;
  line-height: 24px;
  &:hover {
    box-shadow: 0px 2px 4px 0px #00000014;
    box-shadow: 0px 6px 20px 0px #00000014;
    background-color: #f6f6f6;
  }
}

.UsersTableElements_container__G23uv > div:first-child {
  width: 50px;
}

.UsersTableElements_container__G23uv > div:not(:first-child):not(:nth-last-child(-n + 3)) {
  width: 120px;
  display: inline-block;
  white-space: normal;
  word-wrap: break-word;
}

.UsersTableElements_container__G23uv > div:nth-last-child(-n + 2) {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.UsersTableElements_container__G23uv > div:nth-last-child(3) {
  width: 70px;
}

.UsersTableElements_container__G23uv img {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/usersTableElements/UsersTableElements.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB;IACE,qCAAqC;IACrC,sCAAsC;IACtC,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  padding: 5px 20px;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  justify-content: space-between;\n  width: 90%;\n  color: #676c7e;\n  line-height: 24px;\n  &:hover {\n    box-shadow: 0px 2px 4px 0px #00000014;\n    box-shadow: 0px 6px 20px 0px #00000014;\n    background-color: #f6f6f6;\n  }\n}\n\n.container > div:first-child {\n  width: 50px;\n}\n\n.container > div:not(:first-child):not(:nth-last-child(-n + 3)) {\n  width: 120px;\n  display: inline-block;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.container > div:nth-last-child(-n + 2) {\n  width: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container > div:nth-last-child(3) {\n  width: 70px;\n}\n\n.container img {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UsersTableElements_container__G23uv`
};
export default ___CSS_LOADER_EXPORT___;
